<template>
	<div>
		<div v-show="!!label" class="label">
			{{ label }}
		</div>
		<div class="component-input-image">
			<div class="image-block">
				<div v-if="!!urlMiniature">
					<img
						:src="urlMiniature"
						ref="uploadImageMiniature"
						accept="image/*"
						class="image"
						alt="Logo"
					/>
				</div>
				<div v-else class="icon">
					<i class="fal fa-image"></i>
				</div>
			</div>
			<input type="file" class="button-add" :accept="types" @change="uploadImage" />
		</div>

		<div v-show="!!alertText" class="alert">
			{{ alertText }}
		</div>

		<div class="observation">
			<small>Formato sugerido: 150 x 50 e MAX 1,5MB.</small>
		</div>
	</div>
</template>

<script>
	import helpers from '@/mixins/helpers'
	import { storage } from '@/services/storage'

	export default {
		name: 'ui-upload-logo',
		mixins: [helpers],
		props: {
			image: {
				type: String,
				default: '',
			},

			maxSize: {
				type: Number,
				default: 1536000,
			},

			label: {
				type: String,
				default: '',
			},

			enableMaxWH: {
				type: Boolean,
				default: false,
			},

			maxWidth: {
				type: Number,
				default: 300,
			},

			maxHeight: {
				type: Number,
				default: 100,
			},

			types: {
				type: String,
				default: 'image/*',
			},
		},

		data() {
			return {
				urlImage: '',
				imageArrayData: null,
				formData: null,
				alertText: '',
			}
		},

		computed: {
			urlMiniature() {
				if (this.urlImage) return this.urlImage
				if (this.image)
					return this.getImgCDN(this.image + `?v=${storage.get('cache_version')}`)
				else return ''
			},
		},

		methods: {
			alertError(error) {
				if (!!error) this.$toastr.e(error)
			},

			uploadImage($e) {
				this.alertText = ''

				this.imageArrayData = $e.target.files
				const selectedImage = this.imageArrayData[0]

				if (selectedImage.size >= this.maxSize) {
					this.alertError('Imagem com tamanho acima do permitido.')
					return
				}

				const fr = new FileReader()
				fr.readAsDataURL(selectedImage)

				fr.onload = (event) => {
					onLoadImage(event)
				}

				const onLoadImage = (e) => {
					const image = new Image()
					image.src = e.target.result

					image.onload = () => {
						if (this.enableMaxWH)
							if (image.height > this.maxHeight || image.width > this.maxWidth) {
								this.alertError('Imagem com dimensão acima do permitido.')
								return
							}

						this.urlImage = e.target.result

						this.formData = new FormData()
						this.formData.append('brandLogo', selectedImage)
						this.$emit('input', this.formData)
					}
				}
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
